const allVideoPopups = document.querySelectorAll('.wp-video-popup__modal');

allVideoPopups.forEach(popup => {
    popup.addEventListener('show.bs.modal', () => {
        const videoUrl = popup.dataset.videoUrl;
        const videoFrame = popup.querySelector('iframe');
        videoFrame.setAttribute('src', videoUrl)
    })

    popup.addEventListener('hide.bs.modal', () => {
        const videoFrame = popup.querySelector('iframe');
        videoFrame.setAttribute('src', '')
    })
})